import React from 'react'
import DisplayPriceBase from './DisplayPriceBase'
import DisplayPriceUiDefault from './DisplayPriceUiDefault'

class DisplayPrice extends React.Component {
    render() {
        const { displayPriceWithoutMeasure, showTotalPriceByQty } = this.props
        return (
            <DisplayPriceBase {...this.props}>
                <DisplayPriceUiDefault displayPriceWithoutMeasure={displayPriceWithoutMeasure} showTotalPriceByQty={showTotalPriceByQty} />
            </DisplayPriceBase>
        )
    }
}

export default DisplayPrice
